/**
 * KissMora — map external URLs to iframe embed players.
 * Returns { type, src } or null for direct-file URLs (mp4/m3u8).
 */
export function parseVideoEmbed(url) {
  if (!url) return null;
  var u = String(url).trim();
  var m;

  // X / Twitter — official embed player (includes video tweets)
  m = u.match(/(?:https?:\/\/)?(?:www\.)?(?:twitter\.com|x\.com)\/\w+\/status\/(\d+)/i);
  if (m) {
    return {
      type: 'twitter',
      src: 'https://platform.twitter.com/embed/Tweet.html?id=' + m[1]
        + '&theme=dark&dnt=true&widgetsVersion=91d384dfb90693fc'
    };
  }

  m = u.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/|shorts\/))([A-Za-z0-9_-]{6,})/);
  if (m) return { type: 'youtube', src: 'https://www.youtube.com/embed/' + m[1] + '?autoplay=1&rel=0' };

  m = u.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (m) return { type: 'vimeo', src: 'https://player.vimeo.com/video/' + m[1] + '?autoplay=1' };

  m = u.match(/pornhub\.com\/(?:embed\/|view_video\.php\?viewkey=)([a-zA-Z0-9]+)/);
  if (m) return { type: 'pornhub', src: 'https://www.pornhub.com/embed/' + m[1] };

  m = u.match(/xhamster\.com\/(?:embed|videos\/[\w-]+)\/?(\d+)/);
  if (m) return { type: 'xhamster', src: 'https://xhamster.com/embed/' + m[1] };

  m = u.match(/xvideos\.com\/(?:embedframe\/|video\.?)(\w+)/);
  if (m) return { type: 'xvideos', src: 'https://www.xvideos.com/embedframe/' + m[1] };

  m = u.match(/youporn\.com\/(?:embed|watch)\/(\d+)/);
  if (m) return { type: 'youporn', src: 'https://www.youporn.com/embed/' + m[1] + '/' };

  m = u.match(/redtube\.com\/(?:embed\/\?id=|)(\d+)/);
  if (m) return { type: 'redtube', src: 'https://embed.redtube.com/?id=' + m[1] };

  m = u.match(/spankbang\.com\/(\w+)\/(?:video|embed)/);
  if (m) return { type: 'spankbang', src: 'https://spankbang.com/' + m[1] + '/embed/' };

  m = u.match(/tnaflix\.com\/video(\d+)/);
  if (m) return { type: 'tnaflix', src: 'https://www.tnaflix.com/xembed.php?video_id=' + m[1] };

  m = u.match(/eporner\.com\/(?:video-|embed\/)([a-zA-Z0-9]+)/);
  if (m) return { type: 'eporner', src: 'https://www.eporner.com/embed/' + m[1] };

  if (/\/embed\//.test(u)) return { type: 'generic', src: u };
  return null;
}

export function isTwitterUrl(url) {
  return /(?:twitter\.com|x\.com)\/\w+\/status\/\d+/i.test(String(url || ''));
}

export function isHlsUrl(url) {
  return /\.m3u8(\?|$)/i.test(String(url || ''));
}
